<div class="grid-container grid-5">
    <div class="grid-span-5">
        <p>
            {{ 'POPOVERS.EXPORT_DASHBOARD.SUMMARY' | translate }}
        </p>
        <div class="grid-container grid-2 medium-padding-bottom">
            <span>{{ 'POPOVERS.EXPORT_DASHBOARD.BOARD_NAME_LABEL' | translate }}</span>
            <span class="bold-text">{{ input().report.label }}</span>
            <span>{{ 'POPOVERS.EXPORT_DASHBOARD.SELECTED_PERIOD_LABEL' | translate }}</span>
            @if (input().period === lastTwelveMonths) {
                <span class="bold-text">{{ 'WIDGET.PERIOD_TWELVE_MONTHS' | translate }}</span>
            } @else {
                <span class="bold-text">
                    {{ 'WIDGET.PERIOD_YEAR' | translate: { year: input().period.toString() | translatePeriod } }}
                </span>
            }
            <span>{{ 'POPOVERS.EXPORT_DASHBOARD.SELECTED_CLASSIFICATION_LABEL' | translate }}</span>
            <span class="bold-text">{{ input().classificationNodeId | classificationNodeName }}</span>
            <span>{{ 'POPOVERS.EXPORT_DASHBOARD.ESTIMATED_ACTIVATED_LABEL' | translate }}</span>
            <span class="bold-text">{{ (input().enableEstimated ? 'STUFF.YES' : 'STUFF.NO') | translate }}</span>
        </div>
    </div>
</div>
<div class="advizeo-toolbar toolbar-right large-padding-top">
    <button ui-button color="primary" class="no-margin" [pending]="generatingReport" (click)="this.validate()">
        {{ (generatingReport ? 'POPOVERS.EXPORT_DASHBOARD.EXPORT_CREATION' : 'POPOVERS.EXPORT_DASHBOARD.EXPORT_PDF') | translate }}
    </button>
</div>
